import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import { Loader2 } from "lucide-react";
import "./App.css";
import { useDispatch } from "react-redux";
import { fetchUserData } from "./redux/userActions";
import ProfileSettings from "./pages/profileSettings/ProfileSettings";
import MainLayout from "@/components/ui/MainLayout";
import HelpCenter from '../src/pages/help/HelpCenter'


// Lazy loaded pages
const LandingPage = lazy(() => import("./pages/login/LandingPage"));
const NewPassword = lazy(() => import("./pages/login/NewPassword"));
const ForgotPage = lazy(() => import("./pages/login/ForgotPage"));
const RestorePassword = lazy(() => import("./pages/login/RestorePassword"));
// const RawPackingMaterialMaster = lazy(() => import("./pages/raw-packing-material-master"));
const CreateBOM = lazy(() => import("./pages/create-bom"));
// const ProductionAreaOverheadDetails = lazy(() => import("./pages/production-area-overhead-details"));
const Admin = lazy(() => import("./pages/admin/Admin"));
const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));


const ProtectedRoute = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/auth" replace />;
  }

  return <Outlet />;
};

const AppRoutes = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // Fetch user data if token exists
      dispatch(fetchUserData());
    }
  }, [dispatch]);


  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense
          fallback={
            <div className="spinner-container">
              <Loader2 className="spin-icon" />
            </div>
          }
        >
          <Routes>
            <Route path="/auth">
              <Route index element={<LandingPage />} />
              <Route path="setup-account" element={<NewPassword />} />
              <Route path="forgotpassword" element={<ForgotPage />} />
              <Route path="restore-password" element={<RestorePassword />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              {/* WITH SIDEBAR */}
              <Route path="/app" element={<MainLayout />}>
                <Route index element={<Navigate to="client-estimates" replace />} />
                {/* <Route path="raw-packing-material-master" element={<RawPackingMaterialMaster />} /> */}
                {/* <Route path="production-area-overhead-details" element={<ProductionAreaOverheadDetails />} /> */}
                <Route path="client-estimates" element={<CreateBOM />} />
                <Route path="admin" element={<Admin />} />
                <Route path="dashboard" element={<Dashboard />} />
      
                {/* <Route path="/app" element={<Layout />}> */}
    
                <Route path='profile-settings' element={<ProfileSettings />} />
                <Route path="/app/helpcenter" element={<HelpCenter />} />
              </Route>
            </Route>

            {/* Redirect root / to /auth */}
            <Route path="/" element={<Navigate to="/auth" replace />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default AppRoutes;
